import * as React from 'react';

import * as styles from './ServicesRow.css';
import { IService } from '../../types/services';
import { ServiceRedesign } from '../ServiceRedesign';

interface IServicesRowProps {
  services: IService[];
  onClick(key: string): (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const ServicesRow: React.FC<IServicesRowProps> = ({ services, onClick }) => {
  return (
    <div className={styles['container']}>
      {services.map(({ key, title, url, image }) => (
        <ServiceRedesign key={`service-${key}`} title={title} url={url} image={image} onClick={onClick(key)} />
      ))}
    </div>
  );
};
